import { useQuery } from '@apollo/client';
import ProgressPage from '../ProgressPage';
import { GetPaypalAccountLinkDocument } from '../../gql/graphql';


const PaypalAccountRedirect = () => {
    const { data, loading, error } = useQuery(GetPaypalAccountLinkDocument, {
        fetchPolicy: 'network-only'
    });

    if (loading) return <ProgressPage
        title="Redirecting to PayPal..."
        spinner={true}
    />;

    if (error) return <div>Error</div>;

    if (data?.paypalAccountLink) {
        // Redirect to the PayPal account link
        window.top ? window.top.location.href = data.paypalAccountLink : window.location.href = data.paypalAccountLink;
    }

    return null;
};

export default PaypalAccountRedirect; 